import React from 'react';
import { Link } from 'react-router-dom';
import { ScissorsIcon, RulerIcon, SparklesIcon, CalendarIcon } from 'lucide-react';
export function Alterations() {
  return <div className="bg-white min-h-screen pt-32 pb-20 px-6" data-id="element-383">
      <div className="max-w-[1800px] mx-auto" data-id="element-384">
        <header className="mb-20 text-center" data-id="element-385">
          <span className="text-xs md:text-sm font-display font-bold uppercase tracking-[0.3em] md:tracking-[0.5em] mb-4 block text-black/40" data-id="element-386">
            Bespoke Services
          </span>
          <h1 className="text-2xl sm:text-4xl md:text-6xl font-display font-bold tracking-[0.1em] md:tracking-[0.2em] uppercase mb-6" data-id="element-387">
            Alterations
          </h1>
          <p className="max-w-xl mx-auto text-sm md:text-base font-light tracking-widest text-black/60 leading-relaxed uppercase px-4 md:px-0" data-id="element-388">
            Precision tailoring and custom adjustments to ensure your heritage
            pieces fit perfectly.
          </p>
        </header>

        {/* Hero Section */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center mb-32" data-id="element-389">
          <div className="aspect-[4/5] bg-grey-divider overflow-hidden" data-id="element-390">
            <img src="https://images.unsplash.com/photo-1598554747436-c9293d6a588f?auto=format&fit=crop&q=80&w=1200" alt="Tailoring Process" className="w-full h-full object-cover grayscale hover:grayscale-0 transition-all duration-700" data-id="element-391" />
          </div>
          <div className="space-y-12" data-id="element-392">
            <div className="space-y-6" data-id="element-393">
              <h2 className="text-xl sm:text-2xl md:text-4xl font-display font-bold tracking-[0.1em] sm:tracking-widest uppercase" data-id="element-394">
                The Perfect Fit
              </h2>
              <p className="text-sm md:text-base font-light tracking-widest text-black/70 leading-relaxed uppercase" data-id="element-395">
                At Djily Creations, we believe that true luxury is found in the
                fit. Our in-house master tailors specialize in the intricate
                construction of traditional African textiles, ensuring that
                every seam and drape honors both the fabric and your silhouette.
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-396">
              <div className="space-y-4" data-id="element-397">
                <ScissorsIcon className="w-6 h-6 stroke-[1px]" data-id="element-398" />
                <h3 className="text-xs md:text-sm font-display font-bold tracking-widest uppercase" data-id="element-399">
                  Precision Cutting
                </h3>
                <p className="text-xs md:text-sm font-light text-black/50 uppercase tracking-widest leading-relaxed" data-id="element-400">
                  Expert adjustments to length, waist, and sleeves for a sharp,
                  modern look.
                </p>
              </div>
              <div className="space-y-4" data-id="element-401">
                <RulerIcon className="w-6 h-6 stroke-[1px]" data-id="element-402" />
                <h3 className="text-xs md:text-sm font-display font-bold tracking-widest uppercase" data-id="element-403">
                  Custom Measurements
                </h3>
                <p className="text-xs md:text-sm font-light text-black/50 uppercase tracking-widest leading-relaxed" data-id="element-404">
                  Full bespoke tailoring based on your unique body measurements.
                </p>
              </div>
            </div>

            <Link to="/booking" className="inline-block bg-black text-white px-12 py-5 text-xs font-display font-bold uppercase tracking-[0.3em] hover:bg-black/80 transition-colors" data-id="element-405">
              Book a Fitting
            </Link>
          </div>
        </div>

        {/* Services Grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 mb-32" data-id="element-406">
          <div className="p-12 bg-grey-divider/10 text-center space-y-6" data-id="element-407">
            <SparklesIcon className="w-8 h-8 mx-auto stroke-[1px]" data-id="element-408" />
            <h3 className="text-xs md:text-sm font-display font-bold tracking-widest uppercase" data-id="element-409">
              Wedding Gowns
            </h3>
            <p className="text-xs md:text-sm font-light text-black/60 uppercase tracking-widest leading-relaxed" data-id="element-410">
              Specialized alterations for bridal wear, including bustle
              additions and intricate lace adjustments.
            </p>
          </div>
          <div className="p-12 bg-grey-divider/10 text-center space-y-6" data-id="element-411">
            <CalendarIcon className="w-8 h-8 mx-auto stroke-[1px]" data-id="element-412" />
            <h3 className="text-xs md:text-sm font-display font-bold tracking-widest uppercase" data-id="element-413">
              Formal Wear
            </h3>
            <p className="text-xs md:text-sm font-light text-black/60 uppercase tracking-widest leading-relaxed" data-id="element-414">
              Tailoring for Prom, Galas, and formal events to ensure you stand
              out with confidence.
            </p>
          </div>
          <div className="p-12 bg-grey-divider/10 text-center space-y-6" data-id="element-415">
            <ScissorsIcon className="w-8 h-8 mx-auto stroke-[1px]" data-id="element-416" />
            <h3 className="text-xs md:text-sm font-display font-bold tracking-widest uppercase" data-id="element-417">
              Heritage Restoration
            </h3>
            <p className="text-xs md:text-sm font-light text-black/60 uppercase tracking-widest leading-relaxed" data-id="element-418">
              Careful repair and resizing of vintage or heirloom heritage
              garments.
            </p>
          </div>
        </div>

        {/* Pricing Note */}
        <div className="max-w-3xl mx-auto text-center border-t border-grey-divider pt-20" data-id="element-419">
          <h2 className="text-xl font-display font-bold tracking-widest uppercase mb-6" data-id="element-420">
            Pricing & Consultations
          </h2>
          <p className="text-sm font-light tracking-widest text-black/60 leading-relaxed uppercase mb-12" data-id="element-421">
            Alteration costs vary based on the complexity of the garment and the
            extent of the changes. We offer a complimentary 15-minute
            consultation to provide an accurate estimate.
          </p>
          <div className="flex flex-wrap justify-center gap-8 text-[11px] font-display font-bold tracking-widest uppercase" data-id="element-422">
            <div className="flex items-center space-x-2" data-id="element-423">
              <span className="w-2 h-2 bg-black rounded-full" data-id="element-424" />
              <span data-id="element-425">Hemming: from $35</span>
            </div>
            <div className="flex items-center space-x-2" data-id="element-426">
              <span className="w-2 h-2 bg-black rounded-full" data-id="element-427" />
              <span data-id="element-428">Waist Adjust: from $45</span>
            </div>
            <div className="flex items-center space-x-2" data-id="element-429">
              <span className="w-2 h-2 bg-black rounded-full" data-id="element-430" />
              <span data-id="element-431">Full Taper: from $85</span>
            </div>
          </div>
        </div>
      </div>
    </div>;
}